import { useEffect, useRef } from "react";
import { Typography as T } from "@mui/material";
import { Box } from "@mui/system";

import { palette } from "theme/palette";

type Props = {
  noVehiclesError: boolean;
};
export const NoVehiclesError = ({ noVehiclesError }: Props) => {
  const componentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (noVehiclesError) {
      if (componentRef.current) {
        componentRef.current.scrollIntoView();
      }
    }
  }, [noVehiclesError]);

  return noVehiclesError ? (
    <Box ref={componentRef}>
      <T variant="h4" color={palette.error} sx={{ fontWeight: 500 }}>
        Sorry, we do not have a route between these two locations. Please adjust
        the start/end location to try again.
      </T>
    </Box>
  ) : null;
};
